<div *ngIf="operatingCompanies$ | async as operatingCompanies">
<div class="sectionContainer" *ngIf="operatingCompanies.length>0">
    <h3>Operating Companies</h3>
    <table class="projectSectionTable">
        <thead>
            <tr>
                <th class="itemHeading firstColumn"></th>
                <th class="itemHeading">Company name</th>
                <th class="itemHeading">Equity share</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let operatingCompany of operatingCompanies">
                <td class="item alignTop">{{operatingCompany.isOperator}}</td>
                <td class="item alignTop">
                    <span [innerHTML]="operatingCompany.companyName | highlight: searchTerm"></span>

                    <a href="{{operatingCompany.companyURL}}"
                        [hidden]="!operatingCompany.companyURL || operatingCompany.companyURL.trim()=='' "
                        target="_blank">

                        <i class="glyphicon glyphicon-globe"></i>
                    </a>
                    <div *ngIf="operatingCompany.constituentCompanies.length>0" class="constituentCompanies">
                        (consists of:
                        <span *ngFor="let constituentCompany of operatingCompany.constituentCompanies">
                            {{constituentCompany}},&nbsp;
                        </span>)
                    </div>
                    <eic-company-offices-and-contacts [company]="operatingCompany"></eic-company-offices-and-contacts>

                </td>

                <td class="item alignTop">{{operatingCompany.equityShare}}%</td>
            </tr>
        </tbody>
    </table>
</div>
</div>
